import React, { useState, useEffect } from 'react';
import './App.css';
import {
  HashRouter,
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import SignupPage from './pages/Signup';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import { useLocation } from 'react-router-dom';
import { isUserAuthenticated } from './services/auth';
import DockviewPersistance from './pages/DockviewPersistance';
import CustomHeader from './components/CustomHeader';

// Import the Dockview API
import { DockviewApi } from 'dockview';

function DashboardRouteAuth({ element, dockviewApi }) {
  if (!isUserAuthenticated()) {
    return <Navigate to="/" />;
  }

  return React.cloneElement(element, { api: dockviewApi }); // Pass the dockviewApi as a prop
}

function LoginRouteAuth({ element }) {
  if (isUserAuthenticated()) {
    return <Navigate to="/streetchart" />;
  }

  return element;
}

function AppWrapper() {
  const location = useLocation();
  const [showHeader, setShowHeader] = useState(false);

  // Create an instance of the Dockview API
  const dockviewApi = new DockviewApi(); // Replace with the actual API initialization code

  useEffect(() => {
    // Check if the current route's pathname starts with '/dashboard' or '/dockview'
    const showHeaderOnRoutes = ['/dashboard'];

    if (showHeaderOnRoutes.some(route => location.pathname.startsWith(route))) {
      setShowHeader(true);
    } else {
      setShowHeader(false);
    }
  }, [location.pathname]);

  return (
    <div className={`min-h-full ${location.pathname !== '/dashboard' && location.pathname !== '/streetchart' ? 'h-screen py-12 px-4 sm:px-6 lg:px-8' : ''} flex items-center justify-center`}>
      <div className={`w-full space-y-8 ${location.pathname !== '/dashboard' && location.pathname !== '/streetchart' ? 'max-w-md' : 'full-container'}`}>
        {showHeader && <CustomHeader />}
        <Routes>
          <Route
            path="/"
            element={
              <LoginRouteAuth element={<LoginPage />} />
            }
          />
          <Route path="/signup" element={<SignupPage />} />
          <Route
            path="/dashboard"
            element={
              <DashboardRouteAuth element={<Dashboard />} dockviewApi={dockviewApi} /> // Pass the dockviewApi as a prop
            }
          />
          <Route
            path="/streetchart"
            element={
              <DashboardRouteAuth element={<DockviewPersistance />} dockviewApi={dockviewApi} /> // Pass the dockviewApi as a prop
            }
          />
        </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <HashRouter>
      <AppWrapper />
    </HashRouter>
  );
}

export default App;
